import { useMatch } from '@tanstack/react-router';
import { useLocation } from '@utils/AvRouter';
import { EntityTypeConfigKeys, EntityViewContext, generateEntityViewConfig } from '@utils/entityViewConfig';
import { getAppIdFromPathName } from '@utils/router.utils';
import { AppPathsValue } from '../../../types';

export const useEntityViewAppContext = (): { entityViewConfigKey?: EntityTypeConfigKeys; context: EntityViewContext } => {
  const matches = useMatch({ strict: false });
  const { key: entityViewConfigKey } = matches.staticData;
  const pathname = useLocation({ select: location => location.pathname });
  const appName = getAppIdFromPathName(pathname) as AppPathsValue;

  return { entityViewConfigKey, context: { appName } };
};

export const useCurrentEntityViewConfig = (entityTypeKey?: EntityTypeConfigKeys | string) => {
  const { entityViewConfigKey, context } = useEntityViewAppContext();
  return generateEntityViewConfig(entityTypeKey ?? entityViewConfigKey, context);
};
